// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FullWidthAdBanner_wrapper__2TRw0","fullWidthAdBanner":"FullWidthAdBanner_fullWidthAdBanner__3fPnk","advertisement":"FullWidthAdBanner_advertisement__1xAz6"};